import { useEffect, useState } from 'react'
import BookingConditionsModal, { BookingConditionsModalProps } from 'components/modals/home/property/BookingConditionsModal'
import Pill from 'components/home/Pill'

const BookingConditionsTrigger = ({
  onIsOpenChange,
  ...props
}: Omit<BookingConditionsModalProps, 'isOpen' | 'onClose'>) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(
    () => onIsOpenChange?.(isOpen),
    [isOpen],
  )

  return (
    <>
      <Pill
        variant="blue"
        size="10"
        onClick={() => setIsOpen(true)}
      >
        Booking Conditions
      </Pill>

      <BookingConditionsModal
        {...props}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}

export default BookingConditionsTrigger
